var exports = {
  "l": "xfd349460--556496--phone",
};

module.exports = exports;
